import "./UpdateTicketLocalSite.scss";
import Sidebar from "../../../components/sidebar/Sidebar";
import Navbar from "../../../components/navbar/Navbar";
import {useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import useFetch from "../../../hooks/useFetch";
import newRequest from "../../../context/newRequest";
import {sleep} from "../../../helper/helper";

const UpdateTicketLocalSite = ({ inputs, title }) => {
    const [ticketLocalsite, setticketLocalsite] = useState({});
    const [ticketUpdateLocalsite, setticketUpdateLocalsite] = useState({});
    const [categoryId, setCategoryId] = useState(false);
    const [statusId, setStatusId] = useState(false);
    const [sending, setSending] = useState("");
    const { ticketId } = useParams();
    const user = localStorage.getItem("user");
    const { data, loading, error } = useFetch(`/ticketsite/${ticketId}`);
    const navigate = useNavigate();

    useEffect(() => {
        setticketLocalsite(data);
    }, [data]);



    const handleSelectCategoryID = (e) => {
        const value = Array.from(
            e.target.selectedOptions,
            (option) => option.value
        );
        setCategoryId(value);
    };

    const handleSelectStatusID = (e) => {
        const value = Array.from(
            e.target.selectedOptions,
            (option) => option.value
        );
        setStatusId(value);
    };


    const handleChange = (e) => {
        setticketUpdateLocalsite((prev) => ({ ...prev, [e.target.id]: e.target.value }));
    };


    const handleClick = async (e) => {
        e.preventDefault();
        setSending("On Submit")
        try {
            setSending("Mengirim Data")
            const newTicketUpdate = {
                ...ticketUpdateLocalsite,
                category_id : categoryId[0],
                status_id : statusId[0]
            };

            const res= await newRequest.put(`/ticketsite/${ticketId}`, newTicketUpdate, {
                // headers
                headers: {
                    'Authorization': `$Bearer ${user.token}`
                },
            });
            if (res.status == 200) {
                await sleep(2000)
                setSending("Berhasil Mengirim Data")
                navigate(`/ticketsite/${ticketId}`);
            }
            console.log(res.status)
        } catch (err) {
            setSending(err.response.data.errors)
            console.log(err);
        }
    };
    return (
        <div className="new">
            <Sidebar />
            <div className="newContainer">
                <Navbar/>
                <div className="top">
                    <h1>{title}</h1>
                </div>
                <div className="bottom">
                    <div className="right">
                        <div className="detailItem">
                            <span className="itemKey">Ticket ID:</span>
                            <span className="itemValue">{ticketId}</span>
                        </div>
                        <div className="detailItem">
                            <span className="itemKey">Site Customer:</span>
                            <span className="itemValue">{ticketLocalsite.customer_site}</span>
                        </div>
                        <form>

                            <div className="formInput">
                                {inputs.map((input) => (
                                    <div className="formInput" key={input.id}>
                                        <label>{input.label}</label>
                                        <input type={input.type} placeholder={input.placeholder} onChange={handleChange}
                                               id={input.id}/>
                                    </div>
                                ))}
                                <label className="label">Category ID</label>
                                <select id="region_id" onChange={handleSelectCategoryID}>
                                    <option value="">Pilih Category Id</option>
                                    <option value="Internal Distribusi Issue">Internal Distribusi Issue</option>
                                    <option value="Vendor Device Problem">Vendor Device Problem</option>
                                    <option value="Fiber Cut">Fiber Cut</option>
                                    <option value="Electrical Issue">Electrical Issue</option>

                                    <option value="ONUBAD">ONU Bad</option>
                                    <option value="FIBERCUT">Fiber Cut</option>
                                    <option value="INTERMITTEN">INTERMITTEN</option>
                                    <option value="LOOPING">LOOPING</option>
                                    <option value="BENDING">BENDING</option>
                                    <option value="ELECTRICAL">ELECTRICAL</option>

                                </select>
                                <label className="label">Status Id</label>
                                <select id="status_id" placeholder="DOWN" onChange={handleSelectStatusID}>
                                    <option>Update Status Ticket</option>
                                    <option value="OPEN">OPEN</option>
                                    <option value="PENDING">PENDING</option>
                                    <option value="SOLVED">SOLVED</option>
                                    <option value="CLOSED">CLOSED</option>
                                    <option value="CANCELED">CANCELED</option>
                                </select>
                                <div>
                                </div>
                                <button onClick={handleClick}>Send</button>
                            </div>
                        </form>
                    </div>
                </div>
                {sending && <p className="error">{sending}</p>}
                <br/>
                <br/>
                <br/>
                <br/>
                <br/>

            </div>
        </div>
    );
};

export default UpdateTicketLocalSite;
